function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self1 = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self1, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { ProtectionCapabilityResult, XboxModelName, VideoColourSpace as ClientVideoColourSpace } from '@sky-uk-ott/client-lib-js-device';
import { AudioFormat } from '../../core/player/audio-format';
import { DEFAULT_VIDEO_FORMAT, VideoColourSpace, VideoFormat } from '../../core/player/video-format';
import { AudioCodecs, UhdHdrCodecs } from '../../utils/probe-utils';
import { UhdHdrCodec, AudioCodecType } from '../../utils/probe-utils.enums';
import { PlaybackType } from '../../core/player/playout-data';
function xboxPreloadBufferConfiguration(deviceInfo) {
    switch(deviceInfo.deviceModel){
        case XboxModelName.One:
            return 6;
        case XboxModelName.OneS:
            return 6.1;
        case XboxModelName.OneX:
            return 5.5;
        case XboxModelName.SeriesS:
            return 4.5;
        case XboxModelName.SeriesX:
            return 4.2;
        default:
            return 6;
    }
}
function isTypeSupported(type, keySystem) {
    return _isTypeSupported.apply(this, arguments);
}
function _isTypeSupported() {
    _isTypeSupported = _async_to_generator(function(type, keySystem) {
        var context, protectionCapabilities, isTypeSupported;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    // https://docs.microsoft.com/en-us/uwp/api/windows.media.protection.protectioncapabilityresult?view=winrt-22000
                    context = self;
                    protectionCapabilities = new context.Windows.Media.Protection.ProtectionCapabilities();
                    isTypeSupported = ProtectionCapabilityResult.Maybe;
                    _state.label = 1;
                case 1:
                    if (!(isTypeSupported === ProtectionCapabilityResult.Maybe)) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        protectionCapabilities.isTypeSupported(type, keySystem)
                    ];
                case 2:
                    isTypeSupported = _state.sent();
                    return [
                        3,
                        1
                    ];
                case 3:
                    return [
                        2,
                        isTypeSupported
                    ];
            }
        });
    });
    return _isTypeSupported.apply(this, arguments);
}
function getMaxVideoFormat() {
    return _getMaxVideoFormat.apply(this, arguments);
}
function _getMaxVideoFormat() {
    _getMaxVideoFormat = _async_to_generator(function() {
        var codec, codecString, resolutionIsSupported, hdcpIsSupported;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    codec = UhdHdrCodec.Uhd;
                    codecString = UhdHdrCodecs[codec].codec;
                    return [
                        4,
                        isTypeSupported("".concat(codecString, ';features="decode-res-x=3840,decode-res-y=2160,decode-bitrate=20000,decode-fps=30,decode-bpc=10,display-res-x=3840,display-res-y=2160,display-bpc=8"'), 'com.microsoft.playready.hardware')
                    ];
                case 1:
                    resolutionIsSupported = _state.sent();
                    if (!(resolutionIsSupported === ProtectionCapabilityResult.Probably)) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        isTypeSupported("".concat(codecString, ';features="hdcp=2"'), 'com.microsoft.playready.hardware')
                    ];
                case 2:
                    hdcpIsSupported = _state.sent();
                    if (hdcpIsSupported === ProtectionCapabilityResult.Probably) {
                        return [
                            2,
                            VideoFormat.UHD
                        ];
                    }
                    _state.label = 3;
                case 3:
                    return [
                        2,
                        DEFAULT_VIDEO_FORMAT
                    ];
            }
        });
    });
    return _getMaxVideoFormat.apply(this, arguments);
}
export function getSupportedColourSpaces(_) {
    return _getSupportedColourSpaces.apply(this, arguments);
}
function _getSupportedColourSpaces() {
    _getSupportedColourSpaces = _async_to_generator(function(param) {
        var display, defaultColourSpaces, codec, codecString, // protectionCapabilities.isTypeSupported -> 0 = does not comply; 1 = did not fully test in time; 2 = does comply
        // According to the Microsoft reference app this check is done before checking the HDMI display profiles
        hdrIsSupportedResult, _display_getSupportedColourSpaces, colourSpaces, convertedColourSpaces, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, colourSpace;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    display = param.display;
                    defaultColourSpaces = [
                        VideoColourSpace.SDR
                    ];
                    codec = UhdHdrCodec.Hdr10;
                    codecString = UhdHdrCodecs[codec].codec;
                    return [
                        4,
                        isTypeSupported("".concat(codecString, ';features="decode-res-x=3840,decode-res-y=2160,decode-bitrate=20000,decode-fps=30,decode-bpc=10,display-res-x=3840,display-res-y=2160,display-bpc=10,hdr=1"'), 'com.microsoft.playready.hardware')
                    ];
                case 1:
                    hdrIsSupportedResult = _state.sent();
                    if (!(hdrIsSupportedResult === ProtectionCapabilityResult.Probably)) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        display === null || display === void 0 ? void 0 : (_display_getSupportedColourSpaces = display.getSupportedColourSpaces) === null || _display_getSupportedColourSpaces === void 0 ? void 0 : _display_getSupportedColourSpaces.call(display)
                    ];
                case 2:
                    colourSpaces = _state.sent();
                    convertedColourSpaces = [];
                    if (colourSpaces) {
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(_iterator = colourSpaces[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                colourSpace = _step.value;
                                convertedColourSpaces.push(VideoColourSpace[ClientVideoColourSpace[colourSpace]]);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                    return [
                        2,
                        convertedColourSpaces.length !== 0 ? convertedColourSpaces : defaultColourSpaces
                    ];
                case 3:
                    return [
                        2,
                        defaultColourSpaces
                    ];
            }
        });
    });
    return _getSupportedColourSpaces.apply(this, arguments);
}
function getSupportedAudioFormats() {
    return [
        AudioFormat.STEREO,
        AudioFormat.SURROUND_5_1,
        AudioFormat.SURROUND_7_1,
        AudioFormat.ATMOS
    ];
}
function getSupportedAudioCodecs() {
    return [
        AudioCodecs[AudioCodecType.MPEG_4_SBR].rawCodecsUnquoted,
        AudioCodecs[AudioCodecType.DolbyDigitalPlus].rawCodecsUnquoted
    ];
}
function getPreloadSupport(device) {
    var preloadBufferTimeSecs = xboxPreloadBufferConfiguration(device.deviceInfo);
    return {
        preconstructItems: true,
        preloadItems: true,
        hasPrefetchSupport: true,
        preloadBufferTimeSecs: preloadBufferTimeSecs
    };
}
function getCompatibleStreamPropertyGroups(device) {
    return _getCompatibleStreamPropertyGroups.apply(this, arguments);
}
function _getCompatibleStreamPropertyGroups() {
    _getCompatibleStreamPropertyGroups = _async_to_generator(function(device) {
        var _ref, maxVideoFormat, supportedColourSpaces;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        Promise.all([
                            getMaxVideoFormat(),
                            getSupportedColourSpaces(device)
                        ])
                    ];
                case 1:
                    _ref = _sliced_to_array.apply(void 0, [
                        _state.sent(),
                        2
                    ]), maxVideoFormat = _ref[0], supportedColourSpaces = _ref[1];
                    return [
                        2,
                        [
                            {
                                maxFrameRate: Infinity,
                                maxVideoFormat: maxVideoFormat,
                                supportedColourSpaces: supportedColourSpaces
                            }
                        ]
                    ];
            }
        });
    });
    return _getCompatibleStreamPropertyGroups.apply(this, arguments);
}
function getHdcpCompliance() {
    return _getHdcpCompliance.apply(this, arguments);
}
function _getHdcpCompliance() {
    _getHdcpCompliance = _async_to_generator(function() {
        return _ts_generator(this, function(_state) {
            return [
                2,
                true
            ];
        });
    });
    return _getHdcpCompliance.apply(this, arguments);
}
function endOfStreamSeekTolerances() {
    return _define_property({}, PlaybackType.Clip, 2);
}
export var mseUwpCapabilities = {
    getCompatibleStreamPropertyGroups: getCompatibleStreamPropertyGroups,
    getSupportedAudioFormats: getSupportedAudioFormats,
    getSupportedAudioCodecs: getSupportedAudioCodecs,
    getPreloadSupport: getPreloadSupport,
    getHdcpCompliance: getHdcpCompliance,
    endOfStreamSeekTolerances: endOfStreamSeekTolerances
};

//# sourceMappingURL=mse-capabilities.js.map